import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { ShuffleRequest } from '../api/shuffle/shufflerequest';
import { ShuffleResponse, ShuffleResponseDtoImpl } from '../api/shuffle/shuffleresponse';
import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';
import { SixdeeCRBTAPIProcessor } from './sixdeecrbtapiprocessor';



export class ShuffleActivationAndDeactivationAPIProcessorImpl  extends SixdeeCRBTAPIProcessor<ShuffleRequest, ShuffleResponse>
{
    execute(request: ShuffleRequest): void {
        super.execute(request);
    }

    onSuccess(responseMapper: ResponseMapper): void 
    {
        super.onSuccess(responseMapper);
        try 
        {
            if (+responseMapper.getStatusCode() === StatusCodes.SUCCESS)
             {
                let response = new ShuffleResponseDtoImpl(APIFeatures.SHUFFLE,responseMapper.getStatusMsg());

                
                this.getAPISuccess(response);
            }
        }
        catch (e)
        {
            this.getAPIFailure(new ShuffleResponseDtoImpl(APIFeatures.SHUFFLE, responseMapper.getStatusMsg()));
        }
    }
    onFailure(responseMapper: ResponseMapper): void 
    {
        super.onFailure(responseMapper);

            this.getAPIFailure(new ShuffleResponseDtoImpl(APIFeatures.SHUFFLE, responseMapper.getStatusMsg()));
        
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/shuffleactivationeactivationapiprocessor.tsx